import {
  PARAMS_ACCESS_TOKEN,
  PARAMS_CLIENT_ID,
  PARAMS_ENVIRONMENT,
  PARAMS_TRANSFER_INTENT_REFERENCE,
  PARAMS_USER_ID,
  PARAMS_WEB_VIEW,
} from "manifest-bridge-core/src/urlParams";

import { AuthenticationRequestParams } from "./authenticate";

const parseUrl = (url: string): AuthenticationRequestParams & { webview: boolean } => {
  const params = new URL(url).searchParams;
  const accessToken = params.get(PARAMS_ACCESS_TOKEN) as string;
  const clientId = params.get(PARAMS_CLIENT_ID) as string;
  const environment = params.get(PARAMS_ENVIRONMENT) as string;
  const transferIntentId = params.get(PARAMS_TRANSFER_INTENT_REFERENCE) as string;
  const userId = params.get(PARAMS_USER_ID) as string;
  const webview = params.get(PARAMS_WEB_VIEW) as string;
  return {
    accessToken,
    clientId,
    environment,
    transferIntentId,
    userId,
    webview: webview === "true",
  };
};

export default parseUrl;
